import { ReactNode, useState } from "react";
import { Box, Card, Collapse, IconButton, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useTranslation } from "react-i18next";
import { common, financedEmissions } from "../../i18n";

interface Props {
  /** section number, rendered as "Section N" */
  index: number;
  title: string;
  defaultOpen?: boolean;
  children: ReactNode;
}

/** Collapsible card section used by the PCAF report preview. */
const CollapsibleSection = ({ index, title, defaultOpen, children }: Props) => {
  const { t } = useTranslation([financedEmissions, common], {
    nsMode: "fallback",
  });
  const [open, setOpen] = useState(defaultOpen ?? false);
  return (
    <Card variant="outlined" sx={{ borderRadius: "8px" }}>
      <Box
        onClick={() => setOpen((o) => !o)}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          p: "14px 20px",
        }}
      >
        {/* Figma node 6163:9312 — "Section N" Inter Medium 14/24 in green,
            a #dedede divider, then the title Inter Medium 14/24 in near-black. */}
        <Typography
          fontSize="14px"
          lineHeight="24px"
          fontWeight={500}
          color="var(--green)"
          whiteSpace="nowrap"
        >
          {t("Section-N", { index })}
        </Typography>
        <Typography fontSize="12px" color="var(--gray5)">
          |
        </Typography>
        <Typography
          flex={1}
          fontSize="14px"
          lineHeight="24px"
          fontWeight={500}
          color="var(--dark)"
        >
          {title}
        </Typography>
        <IconButton size="small">
          {open ? (
            <KeyboardArrowDownIcon fontSize="small" />
          ) : (
            <KeyboardArrowRightIcon fontSize="small" />
          )}
        </IconButton>
      </Box>
      <Collapse in={open} unmountOnExit>
        <Box p="0 20px 20px" borderTop="1px solid var(--gray6)" pt="16px">
          {children}
        </Box>
      </Collapse>
    </Card>
  );
};

export default CollapsibleSection;
